const version = "2.32.1"

module.exports = version
